export default function isCancellationError(error) {
  return ['backdrop', 'overlay', 'cancel', 'close', 'esc', 'timer'].indexOf(error) !== -1
}
